module.exports = __webpack_public_path__ + "media/images/countryrect/nf-8bd4b5388f4b1460a0573f2025fe6ea3.svg";